export default __webpack_public_path__ + "static/media/right-from-bracket-solid-full.da4167fd.svg";